import { Accordion as MUIAccordion } from '~/common/mui/MUIAccordion';

import Box from '../../Box';
import QuestionLibraryBuilder from '../QuestionLibraryBuilder';
import { useConditionsEvaluator } from '../utils/useConditionsEvaluator';

export const MUIAccordionWrapper = ({ component }) => {
  const { name, children, title, conditions, defaultExpanded } = component;
  const { isVisible } = useConditionsEvaluator(conditions);

  if (!isVisible) return null;

  return (
    <Box
      sx={{
        my: 4,
      }}
    >
      <MUIAccordion
        data-testId={name}
        defaultExpanded={defaultExpanded ?? false}
        header={title}
      >
        <QuestionLibraryBuilder questions={children} />
      </MUIAccordion>
    </Box>
  );
};
